import React, { useCallback, useEffect, useState } from 'react';
import './../Form.scss';
import './DestaqueHome.scss';
import { useHistory, useParams } from 'react-router';
import service from '../../../services/destaquesHome';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import UploadS3 from '../../../components/uploadS3/UploadS3';
import { hasText } from '../../../utils/utils';


const DestaquesForm = props => {

    const history = useHistory();
    const params = useParams();
    const [registro, setRegistro] = useState({});
    const [imagemDestaque, setImagemDestaque] = useState(null);
    const { register, handleSubmit } = useForm();

    const onSubmit = data => {
        save(data);
    };
    const save = async (data) => {
        data["imagem"] = imagemDestaque;
        

        const res = await service.upsert(data, registro._id);
        if (!res.erro) {
            if(props.carrossel){
                history.push('/painel/carrossel-home');
            } else {
                history.push('/painel/destaques-home');
            }
        } else {
            alert(res.msg);
        }
    }

    const carregarRegistro = useCallback(async (id) => {
        const reg = await service.getById(id);
        
        setRegistro(reg);
        if (reg.imagem && reg.imagem.length > 0) {
            setImagemDestaque(reg.imagem);
        }
    }, []);

    useEffect(() => {
        if (params.id) {
            carregarRegistro(params.id);
        }
    }, [carregarRegistro, params.id]);


    const setImagem = async (params, returnData) => {
        console.log(returnData);
        setImagemDestaque(returnData.Location);
    }

    const deleteImagem = () => {
        setImagemDestaque(null);
    }

    const optionsJanela = () => {
        const op = [
            { value: '_blank', label: 'Nova' },
            { value: '_self', label: 'Mesma' },
        ];
        op.unshift({ value: "", label: "Selecione uma opção" });
        return op.map((o, i) => {
            return <option key={i} value={o.value}>{o.label}</option>;
        });
    }

    const changeJanela = e => {
        const reg = { ...registro };
        reg.janela = e.target.value;
        setRegistro(reg);


    }

    const cancelar = () => {
        if(props.carrossel){
            history.push('/painel/carrossel-home');
        } else {
            history.push('/painel/destaques-home');
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="formModule branco destaqueHome">
            <div className="acoes">
                <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                <button type="button" className="cancelar" onClick={() => cancelar()}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
            </div>
            <div className="break"></div>


            <div className="field">
                <input className={registro.descricao ? 'hasText' : ''} name="descricao" id="descricao" defaultValue={registro.descricao} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                <label htmlFor="descricao">Descrição</label>
            </div>
            <div className="break"></div>
            <div className="field">
                <input className={registro.descricao ? 'hasText' : ''} name="url" id="url" defaultValue={registro.url} onKeyUp={(e) => hasText(e)} type="text" ref={register()} />
                <label htmlFor="url">URL de direcionamento</label>
            </div>
            <div className="field">
                <select name="janela" className="hasText" ref={register()} id="janela" value={registro.janela || ""} onChange={(e) => changeJanela(e)}>
                    {optionsJanela()}
                </select>
                <label htmlFor="carrossel">Janela</label>
            </div>
            <input name="carrossel" className="hasText hidden" type="checkbox" ref={register()} defaultChecked={props.carrossel} />
            
            
            <div className="break"></div>
            <div className="subtitulo">Arquivo do catálogo</div>
            <div className="break"></div>
            <div className="fieldFile">
                {!imagemDestaque && <UploadS3 bucket="lekamedia" folder="destaques-home" extensions={['jpg','jpeg', 'png']} callback={setImagem} />}
                {imagemDestaque &&
                    <div className="imagem">
                        <img src={imagemDestaque} alt="imagem" />
                        <div className="acoesImagem">
                            <button onClick={(e) => { e.preventDefault(); deleteImagem() }}><FontAwesomeIcon icon={faTrashAlt} /></button>
                        </div>
                    </div>
                }
            </div>
            <div className="break"></div>
            <div className="acoes">
                <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                <button type="button" className="cancelar" onClick={() => cancelar()}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
            </div>
        </form>
    );
    // // const history = useHistory();
    // // const params = useParams();
    // // const [destaquesHome, setDestaquesHome] = useState({});
    // // const [imagemCapa, setImagemCapa] = useState(null);
    // // const { register, handleSubmit, errors, setValue } = useForm();

    // // const onSubmit = data => {
    // //     save(data);
    // // };

    // // const carregarDestaquesForm = useCallback(async (id) => {
    // //     const destaquesFormInicial = await carregaDestaquesHomeById(id);
    // //     setDestaquesHome(destaquesFormInicial);

    // //     if (destaquesFormInicial.imagem && destaquesFormInicial.imagem.length > 0) {
    // //         const preImagem = imageUpload(destaquesFormInicial.imagem, false);
    // //         setImagemCapa(preImagem);
    // //     }
    // // }, []);

    // // useEffect(() => {
    // //     if (params.id) {
    // //         carregarDestaquesForm(params.id);
    // //     }
    // // }, [carregarDestaquesForm, params.id]);

    // // const save = async (data) => {
    // //     const res = await upsert(data, destaquesHome._id);
    // //     if (!res.erro) {
    // //         history.push("/painel/destaques-home");
    // //     } else {
    // //         alert(res.msg);
    // //     }
    // // }

    // // const addImagemCapa = async e => {
    // //     const data = await fileToDataUri(e.target.files[0]);

    // //     if (data) {
    // //         const imagem = imageUpload(data);
    // //         setImagemCapa(imagem);
    // //         const upload = await uploadFile(data);
    // //         if (upload) {
    // //             const imagemAtual = { ...imagemCapa };
    // //             imagemAtual.isUploading = false;
    // //             imagemAtual.data = upload;
    // //             setImagemCapa(imagemAtual);
    // //             setValue('imagem', upload);
    // //         }
    // //     }
    // // }

    // // const deleteImagem = () => {
    // //     setImagemCapa(null);
    // //     setValue('imagem', '');
    // // }

    // // return (
    // //     <form onSubmit={handleSubmit(onSubmit)}>
    // //         <div className="filter">
    // //             <div className="row-title">{params.id ? 'Editar' : 'Criar'}</div>
    // //         </div>
    // //         <div className="filter">
    // //             <input className="userInput" name="descricao" defaultValue={destaquesHome.descricao} type="text" placeholder="Descrição" ref={register({ required: true })} />
    // //         </div>
    // //         <div className="filter">
    // //             <input name="carrossel" defaultValue={true} type="checkbox" ref={register()} defaultChecked={destaquesHome.carrossel}/>&nbsp;Carrossel
    // //         </div>
    // //         <div className="filter">
    // //             <input className="userInput" name="url" defaultValue={destaquesHome.url} type="text" placeholder="URL de direcionamento" ref={register()} />
    // //         </div>
    // //         <div className="filter">
    // //             <select name="janela" ref={register({required:true})}>
    // //                 <option value="">Selecione</option>
    // //                 <option value="_blank" selected={destaquesHome.janela === "_blank"}>Nova janela</option>
    // //                 <option value="_self" selected={destaquesHome.janela === "_self"}>Mesma janela</option>
    // //             </select>
    // //         </div>
    // //         <div className="filter">
    // //             <input type="hidden" name="imagem" defaultValue={destaquesHome.imagem} ref={register({required:true})} />
    // //             {!imagemCapa && <input className="userInput" type="file" onChange={e => addImagemCapa(e)} />}
    // //             {imagemCapa && imagemCapa.data &&
    // //                 <div className="imagem">
    // //                     <img src={imagemCapa.data} height="200" alt="imagem" />
    // //                     {!imagemCapa.isUploading && 
    // //                         <div className="acoesImagem">
    // //                             <button onClick={(e) => { e.preventDefault(); deleteImagem() }}><FontAwesomeIcon icon={faTrashAlt} /></button>
    // //                         </div>
    // //                     }
    // //                     {imagemCapa.isUploading && <div className="loadingImage">
    // //                         <FontAwesomeIcon icon={faRedoAlt} />
    // //                     </div>
    // //                     }

    // //                 </div>
    // //             }
    // //         </div>
    // //         <div className="filter">
    // //             <button type="submit" className="userButton">{params.id ? 'Editar' : 'Salvar'}</button>
    // //             <button type="button" className="userButton" onClick={() => history.push('/painel/destaques-home')}>Cancelar</button>
    // //         </div>
    // //     </form>
    // )

}

export default DestaquesForm;